import React from 'react';
import { Adsense } from '@ctrl/react-adsense';

export default class Ad extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    };

    componentDidMount() {
    };
    
    
    render() {
        return null;

        return (
            <>
            <Adsense
                client="ca-pub-6126055432724833"
                slot="7580130202"
                style={{ display: 'block' }}
                format="responsive"
                responsive='true'
            />
                {/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6126055432724833"
                    crossorigin="anonymous"></script>
                <ins class="adsbygoogle"
                    style="display:block"
                    data-ad-client="ca-pub-6126055432724833"
                    data-ad-slot="7580130202"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
                <script>
                    (adsbygoogle = window.adsbygoogle || []).push({});
                </script> */}
            </>
        );
    };
};